import { colors } from "@dotnet/telematics-design-system";

import { body2SemiBold } from "shared";

import { SubtitleProps } from "./types";

const Subtitle = ({ text }: SubtitleProps) => {
    const { gray700 } = colors;

    return (
        <h3
            css={[
                body2SemiBold,
                {
                    color: gray700,
                    marginBottom: "16px"
                }
            ]}
        >
            {text}
        </h3>
    );
};

export { Subtitle };
